import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
const boxClasses = generateUtilityClasses('MuiBox', ['root']);
export default boxClasses;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Box/boxClasses.js
// module id = 493
// module chunks = 25